// extracted by mini-css-extract-plugin
module.exports = {"root":"Chat_root__9O028","messages":"Chat_messages__17dUW","dateDivider":"Chat_dateDivider__zWTzH"};